import { SecurityGroupUtils } from 'cloud-networks/modules/SecurityGroupModule/SecurityGroupUtils';
import { ImagesUtils } from 'images/modules/ImagesModule/ImagesModule';
import * as R from 'ramda';
import React from 'react';
import {
    DEFAULT_SECURITY_GROUP_NAMES,
    FIREWALL_OPTIONS,
    FIREWALL_OPTIONS_WINDOWS,
} from 'services/cloud-networks/modules/SecurityGroupModule/SecurityGroupConstants';

import { FieldMultipleSelect } from 'reactApp/components/Forms/FieldMultipleSelect';

import { connectFormikContext } from './ConnectFormikContext';
import { FieldDependentValue } from './FieldDependentValue';
import styles from './SecurityGroupSelect.css';

@connectFormikContext()
export class SecurityGroupSelect extends React.Component {
    _getOptions = ({
        isWindows = this.props.isWindows,
        securityGroups = this.props.securityGroups,
    } = {}) => {
        const presets = isWindows ? FIREWALL_OPTIONS_WINDOWS : FIREWALL_OPTIONS;

        const userGroups = securityGroups
            .filter((item) => !DEFAULT_SECURITY_GROUP_NAMES.includes(item.name))
            .map((item) => ({
                value: item.id,
                text: `Группа правил "${item.name}"`,
            }));

        const defaultGroup = securityGroups.find(
            SecurityGroupUtils.isDefaultGroup,
        );

        return [
            {
                value: defaultGroup.id,
                text: defaultGroup.name,
            },
            ...presets,
            ...userGroups,
        ].map((option) => {
            option['data-test'] = 'select-settings-firewall-item';

            return option;
        });
    };

    _generateValue = (values) => {
        const currentValue = values[this.props.name];

        const imageId = values[this.props.imageFieldName];
        const image = this.props.images.find(R.propEq('id', imageId));
        const isWindows = ImagesUtils.getIsWindows(image);

        const options = this._getOptions({ isWindows });
        const option = options.find(R.propEq('value', currentValue));

        if (option) {
            return [currentValue];
        }

        return [options[0].value];
    };

    _renderLabel = (label) => {
        return {
            content: label.text,
            className: label.text === 'default' ? styles.defaultLabel : null,
            'data-test': 'select-settings-firewall-label',
        };
    };

    render() {
        const {
            name,
            label,
            imageFieldName,
            securityGroups,
            images,
            isWindows,
            ...otherInputProps
        } = this.props;

        return (
            <FieldDependentValue
                {...{
                    dataTest: 'select-settings-firewall',
                    name,
                    label,
                    fieldControl: FieldMultipleSelect,
                    dependentFieldNames: [imageFieldName],
                    options: this._getOptions(),
                    generateValue: this._generateValue,
                    className: styles.root,
                    renderLabel: this._renderLabel,
                    ...otherInputProps,
                }}
            />
        );
    }
}

SecurityGroupSelect.defaultProps = {
    name: 'firewall',
    label: 'Настройки Firewall',
};
